import React from 'react'
import IconButton from '@mui/material/IconButton'
import { Tooltip } from '@mui/material'
import FilterListIcon from '@mui/icons-material/FilterList'
import PropTypes from 'prop-types'
import { Filter1Outlined, FilterAltSharp } from '@mui/icons-material'

const CustomToolbarFilter = (props) => {
  return (
    <Tooltip title={'Filter Table'}>
      <IconButton onClick={props.filterListener}>
        <FilterAltSharp />
      </IconButton>
    </Tooltip>
  )
}
CustomToolbarFilter.propTypes = PropTypes.shape({
  params: PropTypes.shape({
    filterListener: PropTypes.node,
  }).isRequired,
}).isRequired

export default CustomToolbarFilter
